module.exports = __webpack_public_path__ + "img/organizationImg.f2d0866e.svg";